import BookNowButton from '../components/BookNowButton';
import PageHeader from '../components/PageHeader';

function Services({ services }) {
    // const services = [
    //     {
    //         title: "Service Package 1",
    //         description: "Detailed description of the service...",
    //         price: "XX.XX",
    //     },
    //     {
    //         title: "Service Package 2",
    //         description: "Another service description...",
    //         price: "XX.XX",
    //     },
    //     {
    //         title: "Service Package 3",
    //         description: "Third service description...",
    //         price: "XX.XX",
    //     }
    // ];

    return (
        <div>
            <PageHeader title="OUR SERVICES" />
            <div className="container mx-auto px-4 py-8">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
                    {services.map((service, index) => (
                        <div key={index} className="rounded-lg overflow-hidden shadow-lg bg-pink-800 bg-opacity-40">
                            <div className="p-6 flex flex-col items-center h-full justify-between">
                                <h2 className="text-2xl font-semibold mb-4 text-gray-200">{service.title}</h2>
                                <p className="text-gray-400 mb-4">{service.description}</p>
                                <div className="text-2xl font-bold text-white">${service.price}</div>
                                <BookNowButton />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Services;